import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import HomePage from './HomePage'
import SEO from '../components/SEO'

/**
 * Component that handles SEO route redirects to hash sections
 * Used for /features and /pricing routes
 */
const SEORedirectPage = () => {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    // Map route paths to hash sections
    const routeToHashMap: Record<string, string> = {
      '/features': '#features',
      '/pricing': '#pricing'
    }

    const targetHash = routeToHashMap[location.pathname]
    
    if (targetHash) {
      // Replace current URL with home page + hash
      navigate('/', { replace: true })
      
      // Add hash to URL and scroll to section
      setTimeout(() => {
        window.location.hash = targetHash.substring(1) // Remove # from hash
        
        // Scroll to the section
        const element = document.getElementById(targetHash.substring(1))
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 100)
    }
  }, [location.pathname, navigate])

  // Get page-specific SEO data
  const getSEOData = () => {
    switch (location.pathname) {
      case '/features':
        return {
          title: 'Features - Chrono Session | AI-Powered Browser Session Manager',
          description: 'Discover Chrono Session\'s powerful features: AI tab organization, smart session management, cross-device sync, collaborative sharing, and advanced analytics. Transform your browsing workflow.',
          keywords: 'chrono session features, AI tab organization, smart session management, browser productivity features, tab grouping, session analytics, cross-device sync, collaborative browsing, browser automation, intelligent tab management'
        }
      case '/pricing':
        return {
          title: 'Pricing - Chrono Session | Free AI Browser Session Manager',
          description: 'Chrono Session is completely free! Get unlimited sessions, AI-powered organization, cloud sync, and all premium features at no cost. Start organizing your browser tabs today.',
          keywords: 'chrono session pricing, free browser extension, free tab manager, chrome extension pricing, free session manager, browser productivity free, no cost tab organizer, free browser tools'
        }
      default:
        return {}
    }
  }

  const seoData = getSEOData()

  // Render the HomePage component with specific SEO
  return (
    <>
      {Object.keys(seoData).length > 0 && <SEO {...seoData} />}
      <HomePage />
    </>
  )
}

export default SEORedirectPage
